const DateTransform = (date) => {
    const parsedDate = date.split('.');
    const event = new Date(Date.UTC(+parsedDate[2], +parsedDate[1] - 1, +parsedDate[0]));
    const options = { month: 'long', day: 'numeric' };
    return event.toLocaleDateString('ru-RU', options);
};


export default DateTransform;
